export default __webpack_public_path__ + "static/media/11_creator 1.503007ad.svg";